import { useSelector } from "react-redux"
import { selectPracticeEnumTableData } from "../../domain/CMS/model"
import { StateOrTerritory } from "../../domain/Practices/schema"
import { useMemo } from "react"

export function useStateMap(): Record<string, string> {
  const practiceEnumTableData = useSelector(selectPracticeEnumTableData)

  const stateMap: Record<string, string> = useMemo(() => {
    const map = {} as Record<string, string>
    if (practiceEnumTableData) {
      const stateOrTerritories = Array.isArray(
        practiceEnumTableData.statesOrTerritories,
      )
        ? (practiceEnumTableData.statesOrTerritories as unknown as StateOrTerritory[])
        : []
      stateOrTerritories.forEach((sot) => {
        map[sot.name] = sot.code
      })
    }
    return map
  }, [practiceEnumTableData])

  return stateMap
}

export function useStateOrTerritoryList() {
  const stateMap = useStateMap()
  const stateOrTerritoryList = useMemo(() => {
    return Object.keys(stateMap)
      .map((key) => {
        return {
          label: key,
          value: key,
          abbreviation: stateMap[key],
        } as Option<string>
      })
      .sort((a, b) => a.label.localeCompare(b.label))
  }, [stateMap])

  return stateOrTerritoryList
}

export function getStateCode(
  stateMap: Record<string, string>,
  stateOrTerritory: string,
): string | undefined {
  return stateMap[stateOrTerritory]
}

export function getStateName(
  stateMap: Record<string, string>,
  stateCode: string,
): string | undefined {
  const names = Object.entries(stateMap).find(([, code]) => code === stateCode)
  return names ? names[0] : undefined
}
